import { Dispatch } from "redux";
import {
  AuthActionTypes,
  loginFailure,
  loginSuccess,
} from "../store/actions/adminAuthActions";
import { signIn, logout as logoutApi } from "../apis/admin";

interface DecodedToken {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  permission: string;
}

export const AdminAuthService = {
  login: async (
    email: string,
    password: string,
    dispatch: Dispatch<AuthActionTypes>
  ) => {
    try {
      const res = await signIn({ email: email, password: password })
      if (res?.error) {
        dispatch(loginFailure(res?.error));
      }
      if (res?.access_token) {
        localStorage.setItem("admin_access_token", res.access_token);
        if (res.refresh_token) {
          localStorage.setItem("admin_refresh_token", res.refresh_token);
        }
        if (res.expires_in) {
          const expiresAt = Date.now() + res.expires_in * 1000;
          localStorage.setItem("admin_token_expires_at", String(expiresAt));
        }
        dispatch(loginSuccess(res.access_token));
        return true;
      }
    } catch (error: any) {
      // Dispatch login failure action
      dispatch(loginFailure(error.message));
    }
  },

  logout: async (dispatch: Dispatch<AuthActionTypes>) => {
    // Call backend to blacklist the token before clearing
    try {
      await logoutApi();
    } catch (err) {
      // Proceed with local logout even if backend call fails
    }
    // Clear tokens from localStorage on logout
    localStorage.removeItem("admin_access_token");
    localStorage.removeItem("admin_refresh_token");
    localStorage.removeItem("admin_token_expires_at");
  },

  getToken: () => {
    // Retrieve token from localStorage
    return localStorage.getItem("admin_access_token");
  },

  isAuthenticated: () => {
    // Check if token exists in localStorage
    return !!localStorage.getItem("admin_access_token");
  },
};
